import {
  Box,
  Button,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import { OrderType } from "models/order_type";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";
interface IOrderValue {
  accountSelected: OrderType;
  calculoAprovado: boolean;
  approve: (type: string) => void;
  reprove : (type: string) => void;
}

const OrderValue = ({ accountSelected, reprove, approve, calculoAprovado }: IOrderValue) => {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [custoFixo, setCustoFixo] = useState(0);
  const [custoVenda, setCustoVenda] = useState(0);
  const [custoProduto, setCustoProduto] = useState(0);
  const [lucro, setLucro] = useState(0);
  const [custoProdutoLucro, setCustoProdutoLucro] = useState(0);
  const [precoLiquido, setPrecoLiquido] = useState(0);
  const [imposto, setImposto] = useState(0);
  const [descontoValor] = useState(accountSelected?.desconto);
  const [acrescimoValor] = useState(
    accountSelected?.acrescimo
  );
  const [comissaoValor] = useState(accountSelected?.comissao);
  const [textoAcrescimo] = useState("0");
  const [categAcrescimo] = useState(
    accountSelected?.tipoAcrescimo
  );
  const [textoComissao] = useState("0");
  const [categComissao] = useState(
    accountSelected?.tipoComissao
  );
  const [textoDesconto] = useState("0");
  const [categDesconto] = useState(
    accountSelected?.tipoDesconto
  );
  const [totalOrder, setTotalOrder] = useState(0);

  useEffect(() => {
    const calcula = () => {
      if (accountSelected?.modeloNegocio) {
        const custofixo =
          (accountSelected?.modeloNegocio.custoFixo * accountSelected?.total) /
          100;
        const custovenda =
          (accountSelected?.modeloNegocio?.custoVenda *
            accountSelected?.total) /
          100;
        const totalcustoproduto = Number(
          custofixo + custovenda + Number(accountSelected?.total)
        );
        const lucrovalor =
          (accountSelected?.modeloNegocio?.metaLucro * totalcustoproduto) / 100;
        const custoprodutolucro = totalcustoproduto + lucrovalor;
        const custoprodutoliquido =
          custoprodutolucro + comissaoValor + acrescimoValor - descontoValor;
        const valorImposto =
          (custoprodutoliquido /
            (100 - accountSelected?.modeloNegocio?.imposto)) *
            100 -
          custoprodutoliquido;
        let calculaTotal = 0;
        calculaTotal = custoprodutoliquido + valorImposto;
        setTotalOrder(calculaTotal);
        setCustoFixo(custofixo);
        setCustoVenda(custovenda);
        setCustoProduto(totalcustoproduto);
        setLucro(lucrovalor);
        setCustoProdutoLucro(custoprodutolucro);
        setPrecoLiquido(custoprodutoliquido);
        setImposto(valorImposto);
      }
    };

    calcula();
  }, [
    accountSelected?.modeloNegocio,
    accountSelected?.total,
    acrescimoValor,
    comissaoValor,
    descontoValor,
    textoDesconto,
  ]);

  return (
    <>
      <Box mb={"48px"}>
      <Box mb={"32px"} flexDirection={"row"}>
        <Stack direction={["column", "row"]} spacing="24px">
          <Text
            textAlign="left"
            color={"#422AFB"}
            fontWeight={"bold"}
            fontSize={24}
            w={"auto"}
            mt={4}
          >
            Revisão do Cálculo de Orçamento :
          </Text>
          {calculoAprovado ? (
            <Text color={"green"} fontWeight={"bold"} mt={6}>
              Cálculo Aprovado
            </Text>
          ) : (
            <Text color={"red"} fontWeight={"bold"} mt={6}>
              Cálculo em revisão
            </Text>
          )}
        </Stack>
        <Button colorScheme="red" variant="solid" float={"right"} mt={-12}         
          onClick={() => {
            reprove("3");
          }} >
          REVISAR
        </Button>
        <Button
          colorScheme="green"
          variant="solid"
          float={"right"}
          mt={-12}
          mr={108}
          onClick={() => {
            approve("3");
          }}
        >
          APROVAR
        </Button>
      </Box>{" "}
      </Box>

      <SimpleGrid columns={4} spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total Custos de Produção:
          </FormLabel>
          <NumberInput
            precision={2}
            value={formatNumber(Number(accountSelected?.total))}
            isDisabled
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Custos Fixos ({accountSelected?.modeloNegocio?.custoFixo}) %
          </FormLabel>
          <NumberInput
            precision={2}
            step={10000}
            min={0}
            value={formatNumber(custoFixo)}
            isDisabled
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Custos de Venda ({accountSelected?.modeloNegocio?.custoVenda}) %
          </FormLabel>
          <NumberInput
            precision={0}
            step={10000}
            min={0}
            value={formatNumber(custoVenda)}
            isDisabled
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total Custo do Produto
          </FormLabel>
          <NumberInput
            precision={2}
            step={10000}
            min={0}
            value={formatNumber(custoProduto)}
            isDisabled
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Lucro ({accountSelected?.modeloNegocio?.metaLucro}) %
          </FormLabel>
          <NumberInput
            precision={0}
            step={10000}
            min={0}
            value={formatNumber(lucro)}
            isDisabled
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Desconto
          </FormLabel>
          <Select size="md" value={categDesconto}>
            <option value="1">PORCENTAGEM</option>
            <option value="2">VALOR</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor Desconto
          </FormLabel>
          <NumberInput
            precision={2}
            min={0}
            max={
              accountSelected?.tipoDesconto === "1"
                ? Number(
                    (accountSelected?.total *
                      accountSelected?.modeloNegocio?.desconto) /
                      100
                  )
                : 100000
            }
            value={textoDesconto}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total Desconto ({accountSelected?.modeloNegocio?.desconto}) %
          </FormLabel>
          <NumberInput
            precision={2}
            isDisabled
            min={0}
            max={Number(
              (accountSelected?.total *
                accountSelected?.modeloNegocio?.desconto) /
                100
            )}
            value={formatNumber(descontoValor)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Acrescimo
          </FormLabel>
          <Select size="md" value={categAcrescimo}>
            <option value="1">PORCENTAGEM</option>
            <option value="2">VALOR</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor Acrescimo
          </FormLabel>
          <NumberInput
            precision={2}
            min={0}
            max={100000}
            value={textoAcrescimo}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Acrescimo
          </FormLabel>
          <NumberInput
            precision={2}
            step={10000}
            min={0}
            isDisabled
            value={formatNumber(acrescimoValor)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total do Preço Liquido sem Comissão
          </FormLabel>
          <NumberInput
            precision={0}
            step={10000}
            min={0}
            isDisabled
            value={formatNumber(custoProdutoLucro)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Comissão Adicional
          </FormLabel>
          <Select size="md" value={categComissao}>
            <option value="1">PORCENTAGEM</option>
            <option value="2">VALOR</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor Comissão
          </FormLabel>
          <NumberInput precision={2} min={0} max={100000} value={textoComissao}>
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Comissão Adicional
          </FormLabel>
          <NumberInput
            precision={2}
            step={10000}
            isDisabled
            min={0}
            value={formatNumber(comissaoValor)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total do Preço Liquido
          </FormLabel>
          <NumberInput
            precision={2}
            step={10000}
            min={0}
            isDisabled
            value={formatNumber(precoLiquido)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Impostos ({accountSelected?.modeloNegocio?.imposto}) %
          </FormLabel>
          <NumberInput
            precision={0}
            step={10000}
            min={0}
            isDisabled
            value={formatNumber(imposto)}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Total Orçamento
          </FormLabel>
          <NumberInput
            precision={0}
            step={10000}
            min={0}
            isDisabled
            value={formatNumber(totalOrder)}
            onChange={(e: string) => {}}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </SimpleGrid>
    </>
  );
};
export default OrderValue;
